import { StoreItem } from '../types/store';

/**
 * Finds a block by its ID from an array of blocks.
 * Compares IDs as strings to handle both number and string ID types.
 *
 * @param id - The ID of the block to find (can be number or string)
 * @param items - Array of items to search through
 * @returns The matching block if found, otherwise undefined
 */
export const getItemById = (id: number | string, items: StoreItem[]) => {
    return items.find(item => item.id.toString() === id.toString());
};
